"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Game_1 = __importDefault(require("./Game"));
const Message_1 = __importDefault(require("./components/Message"));
const parseUrlState = () => {
    const location = (0, react_router_dom_1.useLocation)();
    return (0, react_1.useMemo)(() => {
        var _a;
        const params = new URLSearchParams(location.search);
        const multiplayerCode = params.get("code");
        const nickname = params.get("nickname");
        const player = (_a = params.get("player")) !== null && _a !== void 0 ? _a : "";
        const gameMode = multiplayerCode
            ? "private_multiplayer"
            : "singleplayer";
        const isValid = ["P1", "P2"].includes(player) && nickname;
        return isValid
            ? {
                isValid: true,
                player: player,
                gameMode,
                nickname,
                multiplayerCode,
            }
            : {
                isValid: false,
                player: null,
                gameMode: null,
                nickname: null,
                multiplayerCode: null,
            };
    }, []);
};
const GamePage = () => {
    const wsRef = (0, react_1.useRef)();
    const { isValid, player, gameMode, multiplayerCode, nickname } = parseUrlState();
    const [connectionState, setConnectionState] = (0, react_1.useState)(gameMode == "private_multiplayer" ? "not_connected" : "connected");
    const [opponentInfo, setOpponentInfo] = (0, react_1.useState)(gameMode == "singleplayer" ? { nickname: "Rob 🤖" } : null);
    const [tokenPlaced, setTokenPlaced] = (0, react_1.useState)({
        i: -1,
        x: -1,
    });
    (0, react_1.useEffect)(() => {
        if (!isValid || gameMode == "singleplayer") {
            return;
        }
        console.log(`ws://${location.host}/ws`);
        const protocol = location.protocol == "https:" ? "wss" : "ws";
        const websocket = new WebSocket(`${protocol}://${location.host}/ws`);
        wsRef.current = websocket;
        websocket.onopen = () => {
            websocket.send(JSON.stringify({
                event: "connect",
                player: player,
                nickname: nickname,
                code: multiplayerCode,
            }));
            console.log("Ws open");
            setConnectionState("opponent_not_connected");
        };
        websocket.onclose = () => {
            console.log("Ws close");
        };
        websocket.onerror = () => {
            console.log("Ws error");
        };
        websocket.onmessage = (message) => {
            console.log(message);
            const data = JSON.parse(message.data);
            switch (data.event) {
                case "opponentIsConnected": {
                    setOpponentInfo({ nickname: data.opponent.nickname });
                    setConnectionState("connected");
                    break;
                }
                case "tokenPlaced": {
                    setTokenPlaced(({ i }) => ({ i: i + 1, x: data.x }));
                    break;
                }
                default: {
                    console.log("Could not handle message", message);
                }
            }
        };
        return () => websocket.close();
    }, []);
    const handlePlaceToken = (0, react_1.useCallback)((x) => {
        if (!isValid || gameMode != "private_multiplayer") {
            return;
        }
        if (!wsRef.current) {
            console.error("Websocket not connected");
            return;
        }
        wsRef.current.send(JSON.stringify({
            x,
            player: player,
            event: "tokenPlaced",
            code: multiplayerCode,
        }));
    }, []);
    if (!isValid)
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: "/" });
    if (connectionState == "not_connected") {
        return react_1.default.createElement(Message_1.default, { text: "Establishing connection to server..." });
    }
    if (connectionState == "opponent_not_connected") {
        return (react_1.default.createElement(Message_1.default, { text: `Waiting for opponent to connect. Give them this code: ${multiplayerCode}` }));
    }
    const players = player === "P1"
        ? { P1: nickname, P2: opponentInfo.nickname }
        : { P2: nickname, P1: opponentInfo.nickname };
    return (react_1.default.createElement(Game_1.default, { player: player, players: players, gameMode: gameMode, tokenPlaced: tokenPlaced, onPlaceToken: handlePlaceToken }));
};
exports.default = GamePage;
